export function isSectionClass(component) {
  let klass = "section";
  if (component == "animated-services") {
    klass = "";
  }
  return klass;
}
